import { closeMenu } from './_menu_toggle';
import { modalClose } from './_modal';

export function escKeyHandler() {
  document.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') {
      const menuTrigger = document.querySelector('#menu_trigger');
      const modalOpenEl = document.querySelector('.common_modal[aria-hidden="false"]');

      if (menuTrigger && menuTrigger.getAttribute('aria-expanded') === 'true') {
        closeMenu();
      }

      if (modalOpenEl) {
        modalClose();
      }
    }
  });
}